import { Component, Input } from '@angular/core';
import {
    AbstractControl,
    FormControl,
    FormGroup,
    UntypedFormBuilder,
    UntypedFormGroup,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import { AdditionalRequirmentKeys } from '@enuk/model/registration';
import { requirements } from '../proposal.component.config';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Component({
    selector: 'app-priority-service-register',
    templateUrl: './priority-service-register.component.html',
    styleUrl: './priority-service-register.component.scss',
})
export class PriorityServiceRegisterComponent {
    @Input() form!: FormGroup;
    @Input() supplier: string;
    @Input() submitRequested: boolean;
    groupedRequirements: { category: string | null; items: typeof requirements }[] = [];

    constructor(private fb: UntypedFormBuilder) {}

    ngOnInit(): void {
        requirements.forEach((requirement) => {
            if (this.requirementIsNotExcludedForSupplier(requirement)) {
                this.addRequirement(requirement);
            }
        });

        const grouped = requirements.reduce(
            (acc, req) => {
                const key = req.category ?? 'Other';
                if (!acc[key]) acc[key] = [];
                acc[key].push(req);
                return acc;
            },
            {} as Record<string, typeof requirements>,
        );

        this.groupedRequirements = Object.entries(grouped).map(([category, items]) => ({
            category,
            items,
        }));
    }

    public addYearsFromToday(years: number, lowerDate?: boolean): NgbDateStruct {
        const d = new Date();
        d.setFullYear(d.getFullYear() + years);
        return {
            year: d.getFullYear(),
            month: d.getMonth() + 1,
            day: lowerDate ? d.getDate() + 1 : d.getDate(),
        };
    }

    private requirementIsNotExcludedForSupplier(requirement: any) {
        return requirement.exclude.indexOf(this.supplier) === -1;
    }

    private addRequirement(requirement: any) {
        this.form.addControl(requirement.requirementKey, new FormControl(false));

        if (requirement.hasExpiryDate) {
            const expiryDateFormControlName = requirement.requirementKey + '_expiry';

            this.form.addControl(expiryDateFormControlName, new FormControl(null));
            this.form.get(requirement.requirementKey).valueChanges.subscribe((checked) => {
                const expiryDateFormControl = this.form.get(expiryDateFormControlName);
                if (checked) {
                    expiryDateFormControl.setValidators([
                        Validators.required,
                        this.expiryDateTooFarInFutureValidator(),
                    ]);
                } else {
                    expiryDateFormControl.clearValidators();
                    expiryDateFormControl.setValue(null);
                    expiryDateFormControl.markAsPristine();
                }
                expiryDateFormControl.updateValueAndValidity();
            });
        }
    }

    private expiryDateTooFarInFutureValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (!control.value) {
                return null;
            }
            const expiryDate = control.value;
            const expiryDateUtc = moment.utc(
                `${expiryDate.year}-${expiryDate.month}-${expiryDate.day}`,
                'YYYY-MM-DD',
            );
            const tooFarInTheFuture = moment.utc(moment.now()).add(6, 'y').isSameOrBefore(expiryDateUtc);

            return tooFarInTheFuture ? { tooFarInTheFuture: { value: control.value } } : null;
        };
    }
}
